import apiMapbox from './apiMapbox'
import { MAPBOX_API_KEY } from '../utils/apiConstants'

const MapboxService = {
  async getMapboxDirections(locations, waypoints) {
    let params = `${locations}.json?geometries=geojson&overview=full&access_token=${MAPBOX_API_KEY}`
    if (waypoints) {
      params = params.concat(`&waypoints=${waypoints}`)
    }
    const res = await apiMapbox.get(`directions/v5/mapbox/driving/${params}`)
    return res.data
  },
}

export default MapboxService
